import { v1Api } from '@/api/backendApi';
import { getApiV1TrackTagsPopular } from '@/open-api/track-tags/track-tags';

export interface Tag {
  name: string;
  slug: string;
}

export interface Category {
  emoji?: string;
  id: number;
  name: string;
  order?: number;
  /** Parent page for the group. When set, the heading links to it. */
  slug?: string;
  tag: Tag[];
}

export const getComprehensiveListings = async (variant: 'sfx' | 'music') => {
  if (variant === 'music') {
    // Same JSON as PageApi's /page/comprehensivelistings.
    return ((await getApiV1TrackTagsPopular()) ?? []) as Category[];
  }

  const res = await v1Api.get<Category[]>('/page/sfx/comprehensivelistings');

  if (res.status !== 200) {
    throw new Error(
      res.statusText ??
        `Failed to fetch comprehensive listings, status code ${res.status}`
    );
  }

  return res.data;
};
